import React, { useState } from "react";
import { Col, message, Row } from "antd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import "./style.css";
import { fileCompress, getBase64 } from "../../../Utils";
import { CustomLabel } from "../../../Common/style";
import { UploadInput } from "../../../Components/UploadInput";
import { PolicyDetails } from "../CommonData";
import FooterButton from "../../Footer";
import { useEffect } from "react";
import { postUploadDocument } from "../../../Services/apiService";
import { useNavigate } from "react-router-dom";
import { withScroll } from "../../../HOC/withScroll";
import { showMedicalUploadBtn, status_code_constant_data } from "../../../Constant";

const createObjectFromArray = (arr, key, defaultValue) => {
    const result = {};
    arr.forEach(item => {
      const name = item?.[key];
      result[name] = defaultValue;
    });
    return result;
  }
  
const UploadPage = () => {
    const navigate = useNavigate();
    let { applicationID, renewalYear, customerId, proposalDetails } = PolicyDetails();
    const { MemberDetails } = proposalDetails;
    const filteredMemberDetails = MemberDetails?.filter((member) => {
        return showMedicalUploadBtn({
            status: member?.DecisionCode ? member?.DecisionCode : member?.InterimStatusCode,
            type: status_code_constant_data.Add_info,
          });
    })
    const [documentDocs, setDocument] = useState(createObjectFromArray(filteredMemberDetails, 'MemberId', []));
    const [showUploadButton, setShowUploadButton] = useState(true);

    const uploadDocs = ({ files }) => {
        let customObj = {
            DocumentClass: "ProposalDocuments",
            DocumentType: "Medical Requirements",
            SubDocType: "",
            RenewalYear: renewalYear,
            SourceName: "LR",
            ApplicationNumber: applicationID,
            DocCategoryTypeCd: "CHECKLIST",
            DocCategoryCd: "HCADDINFO1",
            DocumentCd: "UWREQ",
            StatusCd: "RECEIVED",
            LifeRayMemberId: null,
            CustomerId: customerId,
            files: files,
        };
        return customObj;
    };

    const onUpload = async () => {
        let obj = {};
        let files;
        setTimeout(() => {
          document.body.classList.remove("loading-indicator-api");
          navigate("/thankyou", { replace: true });
        }, 15000);
        files = Object?.values(documentDocs)?.flat();
        if (files.length === 0) return;
        obj = uploadDocs({
          files: files,
        });
        await postUploadDocument({ ...obj });
    };

    const handleUploadOthers = async (file, key, firstName, memberId) => {
        if(file?.type !== "application/pdf"){
            try {
                file = await fileCompress(file);
            } catch (err) {
                console.error(err);
            }
        }
        getBase64(file, async (base64) => {
            const copy = [...(documentDocs[memberId] ? documentDocs[memberId] : []), { base64, key, file, filename: file.name, member: firstName}];
            setDocument({...documentDocs , [memberId] : [...copy ]});
        });
    };

    const onRemoveOthers = (idx, memberId) => {
        const filterData = documentDocs?.[memberId]?.filter((ele) => {
            return ele.key !== idx;
        });
        setDocument({...documentDocs, [memberId]: filterData});
    };

    useEffect(() => {
        setShowUploadButton(Object?.values(documentDocs)?.every((memArr) => memArr?.length > 0));
    }, [documentDocs]);

    const getDocsLengthByMember = (arr, firstName) => {
        return arr?.filter((item) => item?.member === firstName)?.length;
    }
    const getUploadBlockByType = (subType, firstName, memberId, UWComment = null) => {
        return (
                    <Col span={24}>
                        <div style={{ margin: "10px" }}>
                            <CustomLabel>Document for {firstName}:</CustomLabel><span style={{ fontSize: "12px"}}> {subType}</span>
                        </div>
                        {UWComment && (
                        <div style={{ margin: "10px 10px 20px 10px" }}>
                            <CustomLabel>{`Underwriter's remark: `}</CustomLabel><span style={{ fontSize: "12px"}}> {UWComment}</span>
                        </div>
                        )}
                        <SectionCardWrapper>
                            <div style={{ marginBottom: "22px" }}>
                                <CustomLabel
                                    style={{ display: "block", paddingBottom: "12px" }}
                                    font_size="14"
                                >
                                    Upload From File Folder
                                </CustomLabel>
                            </div>
                            <div className="upload-card-wrapper">
                                <UploadInput
                                    onUpload={(e) => handleUploadOthers(e, documentDocs?.[memberId]?.length, firstName, memberId)}
                                    style={{ margin: "0px 20px 0px 20px " }}
                                    disabled={getDocsLengthByMember(documentDocs?.[memberId], firstName) >= 7}
                                    title={
                                        getDocsLengthByMember(documentDocs?.[memberId], firstName) !== 7 ? "Attach" : "you have uploaded max docs"
                                    }
                                />
                                <div className="upload-card-wrapper">
                                    {documentDocs?.[memberId]?.map((item, i) => {
                                        if(item?.member === firstName){
                                            return (
                                                <UploadInput
                                                    style={{ margin: "0px 10px 0px 0px " }}
                                                    title={item.filename}
                                                    value={item}
                                                    onRemove={(idx) => onRemoveOthers(idx, memberId)}
                                                    hideRemoveBtn={false}
                                                    hideFileName={false}
                                                    doc_key={item?.key}
                                                    key={"others-" + i}
                                                />
                                            );
                                        }
                                        else {
                                            return null;
                                        }

                                    })}
                                </div>
                            </div>
                        </SectionCardWrapper>
                    </Col>
        );
    }
    return (
        <div className="container upload-card-wrapper">
            <Row style={{ width: "100%" }}>
                <Col span={24} style={{ marginTop: "40px" }}>
                    <CustomLabel font_size="32">Document Upload</CustomLabel>
                </Col>
                <Col>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "20px 0px",
                        }}
                    >
                        <CustomLabel font_weight={"normal"}>
                            You can upload the documents in pdf, jpg, jpeg, png formats only.{" "}
                            <br />
                            Maximum size limit is 3MB.<br />
                            Maximum 7 documents can be uploaded against each member.<br />
                        </CustomLabel>
                    </div>
                </Col>
                {filteredMemberDetails?.map((member) => {
                    const subType = member?.AdditionalDocuments?.map((item) => item?.DocumentSubType)?.join(", ");
                    return getUploadBlockByType(subType, member?.FirstName, member?.MemberId, member?.UWComment);
                })}
                <Col span={24} style={{ marginTop: "20px" }}>
                    <FooterButton
                        nextLabel={"Upload"}
                        hideBack={true}
                        disableNext={!showUploadButton}
                        onNext={() => onUpload()}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default withScroll(UploadPage);
